import * as types from '../types';
import axiosCoto from '../../../services/axiosCoto';

const initialState = {
  isLoggedIn: false,
  token: false,
  user: {},
  corTema: 'emerald',
  posicaoBarra: 'top',
  isLoading: false,
  titleHeader: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS: {
      const newState = { ...state };
      newState.isLoggedIn = true;
      newState.token = action.payload.token;
      newState.user = action.payload.user;
      newState.corTema = action.payload.corTema || 'emerald';
      newState.posicaoBarra = ['side', 'side-collapsed'].includes(action.payload.posicaoBarra) ? action.payload.posicaoBarra : 'top';
      newState.isLoading = false;
      newState.titleHeader = '';
      return newState;
    }

    case types.LOGIN_REQUEST: {
      const newState = { ...state };
      newState.isLoading = true;
      return newState;
    }

    case types.LOGIN_FAILURE: {
      delete axiosCoto.defaults.headers.Authorization;
      const newState = { ...initialState };
      newState.isLoggedIn = false;
      return newState;
    }

    case types.USER_THEME_CHANGE: {
      return {
        ...state,
        corTema: action.payload.corTema || state.corTema,
        posicaoBarra: action.payload.posicaoBarra || state.posicaoBarra,
      };
    }

    case types.TITLEHEADER_CHANGE: {
      const newState = { ...state };
      newState.titleHeader = action.payload.newTitle;
      return newState;
    }

    case types.DATALICENCA_CHANGE: {
      const newState = { ...state };
      newState.user.dataLicenca = action.payload.novaData;
      return newState;
    }

    default: {
      return state;
    }
  }
}

